import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { scrollToTop } from 'utils/Link';

const subMenuStyle = {
  method: { "width": "calc(100% + 70px)" },
  links: { "width": "calc(100% + 40px)" }
};

const SubMenu = ({list, link, locale, item, ...props}) => {
  return (
    <div className="sub-menu" style={subMenuStyle[item]}>
      <ul>
        {list.map(({text, link}) =>
          <li key={Math.random()}>
            {
              /^https?:\/\//.test(link)?
                <a href={link} target="_blank">{text}</a>
                :<Link onClick={scrollToTop} to={`/${locale}${link}`}>{text}</Link>
            }
          </li>
        )}
      </ul>
    </div>
  );
};

export default SubMenu;

SubMenu.propTypes = {
  list: PropTypes.array,
  locale: PropTypes.string,
  style: PropTypes.object,
};

SubMenu.defaultProps = {
  list: [],
  locale: "",
  style: {},
};



// WEBPACK FOOTER //
// ./src/components/Header/SubMenu.js